import { useState } from 'react';
import { Button, Form, FormControl, Modal } from 'react-bootstrap';

const FileUploadModal = ({ file, showModal, setShowModal, handleUpload }) => {
	const [form, setForm] = useState({
		file: file?.name,
		humanName: '',
		description: '',
	});
	const [errors, setErrors] = useState({});

	const handleForm = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const handleModalUpload = () => {
		if (validateInputs()) {
			handleUpload(form);
			setForm({
				file: file?.name,
				humanName: '',
				description: '',
			});
		}
	};

	const validateInputs = () => {
		let errors = {};
		if (!form.humanName) {
			errors.humanName = 'Give the file a human readable name.';
		}
		if (form.humanName && form.humanName.length < 5) {
			errors.humanName = 'At least 5 characters please.';
		}
		setErrors(errors);
		return Object.keys(errors).length === 0;
	};

	return (
		<Modal
			fullscreen="sm-down"
			show={showModal}
			onHide={() => setShowModal(false)}
		>
			<Modal.Header>
				<h4>File Details</h4>
			</Modal.Header>
			<Modal.Body>
				<Form>
					<Form.Group>
						<Form.Label>File:</Form.Label>{' '}
						<div className="d-inline">
							<strong>{file?.name || ''}</strong>
						</div>
					</Form.Group>
					<Form.Group>
						<Form.Label>Name:</Form.Label>
						<FormControl
							type="text"
							name="humanName"
							placeholder="Give your file a descriptive name."
							maxLength={50}
							isInvalid={errors.humanName}
							onChange={handleForm}
						/>
						{errors.humanName && <Form.Text>{errors.humanName}</Form.Text>}
					</Form.Group>
					<Form.Group>
						<Form.Label>Notes:</Form.Label>
						<FormControl
							as="textarea"
							className="formControl"
							name="description"
							placeholder="Optional file notes."
							onChange={handleForm}
						>
							{form.description}
						</FormControl>
					</Form.Group>
					<div className="d-grid mt-4">
						<Button type="button" name="submit" onClick={handleModalUpload}>
							Upload
						</Button>
					</div>
				</Form>
			</Modal.Body>
		</Modal>
	);
};
export default FileUploadModal;
